// extracted by mini-css-extract-plugin
module.exports = {"stylesWrapper":"MapStyles_stylesWrapper__3BfpD","mobileStyleButton":"MapStyles_mobileStyleButton__14loN"};